import { format, isValid } from 'date-fns';

export const CSV_DATE_FORMAT = 'MM/dd/yyyy';
export const CSV_DATE_TIME_FORMAT = 'MM/dd/yyyy hh:mm a';

const toDate = (value: string | number | Date): Date =>
  value instanceof Date ? value : new Date(value);

const hasTimeComponent = (date: Date): boolean =>
  date.getHours() !== 0 || date.getMinutes() !== 0 || date.getSeconds() !== 0;

/**
 * Standard date formatting for dashboard CSV exports:
 * "07/30/2026 12:10 PM" when the value carries a time of day,
 * "07/30/2026" when it is midnight / date-only.
 */
export function formatCsvDate(
  value: string | number | Date | null | undefined
): string {
  if (!value) return '';
  const date = toDate(value);
  if (!isValid(date)) return '';
  return format(
    date,
    hasTimeComponent(date) ? CSV_DATE_TIME_FORMAT : CSV_DATE_FORMAT
  );
}

/**
 * Date-only variant ("07/30/2026") for fields that are calendar dates by
 * definition (birthdays, computed retirement dates) regardless of any time
 * component the raw value carries.
 */
export function formatCsvDateOnly(
  value: string | number | Date | null | undefined
): string {
  if (!value) return '';
  const date = toDate(value);
  if (!isValid(date)) return '';
  return format(date, CSV_DATE_FORMAT);
}
